import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { useParams } from 'react-router'
import { Table, TableSearch } from 'shared/ui/TableNew'
import { Button, EmptyState, SpinnerLoader, Typography } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { useInboxLayerContext } from 'pages/settings/pages/inboxes/context/inboxLayerContext'
import { InboxesPath } from 'pages/settings/pages/inboxes/route/inboxesPath'

import styles from './styles.module.scss'

export const NumbersTabContent = observer(() => {
  const { numbersStore, inboxesViewStore } = useInboxLayerContext()
  const { id } = useParams()
  const {
    getNumbersTableColumns,
    numbersTableRows,
    noResultsFound,
    loading,
    tableStore,
    shouldShowAddNumbersFlow,
  } = numbersStore
  const isManageOrganizationInboxes = inboxesViewStore.inboxesStore.isManageOrganizationInboxes

  const columns = useMemo(() => getNumbersTableColumns, [numbersStore])

  const handleAddNumbers = () => {
    if (!id) return

    inboxesViewStore.inboxesStore.manageNumberWrapper(() => {
      uiStore.changeRoute({
        path: `${InboxesPath.inboxNumbersAddNumber(Number(id))}`,
      })
    })
  }

  if (loading) {
    return <SpinnerLoader ariaLabel={'NumbersTabContent'} />
  }

  const tableContent = noResultsFound ? (
    <EmptyState text='No results found' />
  ) : (
    <div className={styles.tableContainer}>
      <Table
        ariaLabel='numbers-table'
        store={tableStore}
        columns={columns}
        rows={numbersTableRows}
        hidePagination
      />
    </div>
  )

  return (
    <div className={styles.container}>
      <div className={styles.actionsContainer}>
        <Typography ariaLabel='numbers-title' variant='heading-sm'>
          Numbers
        </Typography>
        {(isManageOrganizationInboxes || shouldShowAddNumbersFlow) && (
          <Button text='Add numbers' icon='add' color='primary' onClick={handleAddNumbers} />
        )}
      </div>
      <TableSearch
        className={styles.search}
        value={numbersStore.search}
        onChange={numbersStore.setSearch}
      />
      {tableContent}
    </div>
  )
})
